module.exports = __webpack_public_path__ + "assets/img/anq.4d3f2ce3.png";